import {priority} from '@priority-software/priority-proto-api/lib';
import {getLang} from '../../../../Localization';
import {formatTime} from '../../../Form/utils/date';
import {isHour12Format} from '../../../Form/utils/time';

import {IExtendedCondition, ISearchCondition, ISearchFilter} from '../../types/filters';
import {ApiOperatorMapping, TimeApiOperatorMapping} from '../../types/operator';

function buildQuery(filter: ISearchCondition): IExtendedCondition[] {
    const {values, columnID, operator, columnName} = filter;

    const Values = values.map(time => {
        if (time) {
            return formatTime(time, false);
        }
        return '';
    });
    const op = operator
        ? ApiOperatorMapping[operator]
        : priority.netitems.shared.ComparisonOperator.Eq;

    if (op !== priority.netitems.shared.ComparisonOperator.Between) {
        return [
            {
                Values: [Values[0]?.trim()],
                Operator: op,
                ColumnID: columnID,
                ColumnName: columnName
            }
        ];
    }

    return [
        {
            Values,
            Operator: op,
            ColumnID: columnID,
            ColumnName: columnName
        }
    ];
}

function serialize(condiions: priority.netitems.form.ICondition[]): ISearchFilter {
    const filter = condiions[0];
    const {Values, Operator: queryOperator, ColumnID} = filter;
    const operator = TimeApiOperatorMapping[queryOperator];
    const lang = getLang();

    const minValue = Values[0] ? formatTime(Values[0], isHour12Format(lang)) : '';
    const maxValue = Values[1] ? formatTime(Values[1], isHour12Format(lang)) : '';

    return {
        values: [minValue, maxValue],
        operator,
        columnID: ColumnID
    };
}

export {buildQuery, serialize};
